import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const awardTypeApi = generateNomenApi(`/nomen/award-type`);

export const awardTypeOptions = generateNomenOptions('award-type', awardTypeApi);
